import BaseApi from '@/api/Base/BaseApi'
import {
  Category,
  CategoryCreatePayload,
  CategoryReorderPayload,
  ManualCreatePayload,
  ManualDetail,
  ManualUpdatePayload
} from '@/api/Manual/types'

const ROOT = '/admin/manual'

export default class ManualApi extends BaseApi {
  createManual(payload: ManualCreatePayload) {
    return this.agent.post(`${ROOT}`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  deleteManual(manualId: string) {
    return this.agent.delete(`${ROOT}/${manualId}`)
  }

  getManualDetail(manualId: string) {
    return this.agent.get<ManualDetail>(`${ROOT}/${manualId}`)
  }

  updateManual(manualId: string, payload: ManualUpdatePayload) {
    return this.agent.put(`${ROOT}/${manualId}`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  createCategory(payload: CategoryCreatePayload) {
    return this.agent.post(`${ROOT}/category`, payload)
  }

  deleteCategory(categoryId: string) {
    return this.agent.delete(`${ROOT}/category/${categoryId}`)
  }

  renameCategory(categoryId: string, name: string) {
    return this.agent.put(`${ROOT}/category/${categoryId}`, { name })
  }

  getCategoryList(lang: 'ko' | 'en' = 'ko') {
    return this.agent.get<Category[]>(`${ROOT}/category/list?language=${lang}`)
  }

  reorderCategory(payload: CategoryReorderPayload) {
    return this.agent.put(`${ROOT}/reorder`, payload)
  }
}
